<template>
    <div>
        <div class="footer_wrapper hidden-xs-only">
            <div class="footer_box clearfix">
                <ul class="clearfix">
                    <li class="fl logo">
                        <img
                            src="../../../assets/img/logo2.png"
                            alt=""
                        />
                    </li>
                    <li class="company fl">
                        <span>贵阳市卫生健康投资有限公司</span>
                        <p>Guiyang Health</p>
                    </li>
                    <li class="organizer fl">
                        <span>主办单位：贵阳市卫生健康投资有限公司</span>
                        <span
                            >服务热线：0851-88274300</span
                        >
                        <span><a href="https://beian.miit.gov.cn" target="_blank" style="color: #666; text-decoration: none;">备案序号：黔ICP备2022004082号-1</a></span>
                    </li>
                    <div class="code fl">
                        <img :src="qrCodeUrl" alt="" />
                        <span>微信公众号</span>
                    </div>
                </ul>
            </div>
        </div>
        <div class="footer_phone_wrapper hidden-sm-and-up">
            <div class="footer_phone_box">
                <div style="padding-left:15px;background-color:#fff">
                    <el-collapse v-model="activeNames" @change="handleChange">
                        <el-collapse-item title="主办单位" name="1">
                            <div class="pb20">
                                <span
                                    >主办单位：贵阳市卫生健康投资有限公司</span
                                >
                            </div>
                        </el-collapse-item>
                        <el-collapse-item
                            title="服务热线0851-88274300"
                            name="2"
                        >
                            <div class="img_father">
                                <img
                                    src="../../../assets/img/phone.png"
                                    alt=""
                                />
                                <span>服务热线：0851-88115295</span>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item title="备案序号" name="3">
                            <div class="pb20" style="padding-left: 10px">
                                <a href="https://beian.miit.gov.cn" target="_blank" style="color: #666; text-decoration: none;">备案序号：黔ICP备2022004082号-1</a>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item title="微信公众号" name="4">
                            <div class="code pb20">
                                <img :src="qrCodeUrl" alt=""/>
                                <span>微信公众号</span>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getQrCode } from "@/api/qrcode/qrcode";
export default {
    data() {
        return {
            activeNames: ["1"],
            qrCodeUrl : '',
        };
    },
    mounted() {
        this.getQrcodeInfo();
    },
    methods: {
        handleChange(val) {
            console.log(val);
        },
        getQrcodeInfo() {
            getQrCode().then((res) => {
                console.log(res);
                this.qrCodeUrl = res.data.imageUrl;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/mixin.scss";
//move
.pb20 {
    padding-bottom: px2rem(20);
}
.footer_phone_wrapper {
    width: 100%;
    background-color: #f7f7f7;
    .footer_phone_box {
        width: 100%;
    }
    .img_father {
        position: relative;
        padding-bottom: px2rem(20);
        img {
            position: absolute;
            top: 10%;
            left: px2rem(5);
            width: px2rem(20);
            height: px2rem(20);
        }
        span {
            margin-left: px2rem(30);
        }
    }
    .code {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
            width: px2rem(100);
            height: px2rem(100);
        }
        span {
        }
    }
}
// pc
.footer_wrapper {
    width: 100%;
    box-sizing: border-box;
    border-top: 1px solid #ccc;
    // background-color: #f7f7f7;
    // margin-top: 50px;
    .footer_box {
        box-sizing: border-box;
        width: 1200px;
        height: 230px;
        padding-top: 40px;
        margin: 0 auto;
        color: #666;
        ul {
            li {
                display: table-cell;
                vertical-align: middle;
                height: 140px;
                margin-right: 80px;
                &:nth-child(1) {
                    margin-right: 10px;
                }
            }
            .logo {
                width: 142px;
                height: 126px;
                img {
                    width: 142px;
                    height: 126px;
                }
            }
            .company {
                box-sizing: border-box;
                padding-top: 38px;
                color: #666;
                font-size: 14px;
                line-height: 20px;
                span {
                    color: #333;
                    font-size: 22px;
                }
                p {
                    font-size: 16px;
                    color: #afafaf;
                }
            }
            .organizer {
                span {
                    display: block;
                    color: #666;
                    font-size: 16px;
                    margin-bottom: 20px;
                }
            }
            .code {
                width: 110px;
                text-align: center;
                color: #333;
                font-size: 16px;
                img {
                    width: 100%;
                    height: 110px;
                    margin-bottom: 6px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/iframepage/components/Fotter.vue